export enum EnumTipoFinalizacaoPDV {
    OFFLINESEMPREQUEPOSSIVEL = '0',
    ONLINESEMPREQUEPOSSIVEL = '1',
    ONLINEMAISVALIDACAOESTOQUE = '2'
}